import { SiteControlLayout } from '@scaleaq/sitecontrol-lib';
import { v4 as uuidv4 } from 'uuid';

export const getDefaultNewLayout = (pageName: string): SiteControlLayout => {
  return {
    id: uuidv4(),
    name: 'New layout',
    pageName,
    version: 0,
    order: 0,
    widgets: [],
    isPrivate: true,
  };
};
